/**
 * Handles automatic refreshes of the availability data used to power the
 * booking form.
 *
 * The auto-refresh makes an ajax call to fetch the updated availability data
 * on a timed interval, but only refreshes the data if the user is actively
 * navigating the page.
 */

/**
 * Time (in ms) between each auto-refresh attempt.
 */
const AUTO_REFRESH_INTERVAL = 60 * 1000

/**
 * Requests updated availability data and triggers a refresh of UI elements
 * that depend on this data.
 *
 * @returns {Promise<null>} Returns a promise that resolves when the global
 *                          `priceBandData` and the UI have been updated.
 */
export function refreshAvailabilityData () {
  return fetch(`${appURL}/ajax/aggregated-price-bands-data`)
    .then(response => response.json())
    .then(response => {
      if (response && typeof response === 'object' && 'price_band_mappings' in response) {
        window.priceBandData = response

        // Trigger an update of the price-band selects
        $('.booking-form[data-id] select[name="section"]').trigger('change')
      }
    })
}

(() => {
  /**
   * Whether or not the user interacted with the page in any way since the last
   * auto-refresh interval tick.
   */
  let hasInteractedSinceLastTick = false

  // Set the auto-refresh interval for all availability data
  setInterval(function () {
    if (!hasInteractedSinceLastTick) {
      return
    }

    refreshAvailabilityData()

    hasInteractedSinceLastTick = false
  }, AUTO_REFRESH_INTERVAL)

  function setHasInteracted () {
    hasInteractedSinceLastTick = true
  }

  window.addEventListener('focus', setHasInteracted)
  window.addEventListener('click', setHasInteracted)
  window.addEventListener('scroll', setHasInteracted, { passive: true })
})()



// WEBPACK FOOTER //
// ./resources/assets/js/auto-refresh.js